(
    function (skyward, $, undefined)
    {
        skyward.quickEntryText = skyward.quickEntryText || {};

        const quickEntries = [];

        /**
         * Registers the quick entry text control.
         * @param {HTMLElement | JQuery<HTMLElement>} quickEntryText
         */
        skyward.quickEntryText.registerQuickEntryText = function (quickEntryTextElement)
        {
            const quickEntryText = $(quickEntryTextElement);
            skyward.codeeel.registerCodeEEL(quickEntryText);
            quickEntryText.on("click", ".codeEELButton:not('.ui-disabled')", onOpenCodeEel);
            quickEntryText.on("keydown", "input:not([disabled])", onOpenCodeEel);
            quickEntryText.one("input", "input:not([disabled])", onOpenCodeEel);

            function onOpenCodeEel()
            {
                if (quickEntries[skyward.browse.getCurrentBrowseName()])
                {
                    quickEntries[skyward.browse.getCurrentBrowseName()].off("input", onOpenCodeEel).one("input", "input:not([disabled])", onOpenCodeEel);
                }
                quickEntries[skyward.browse.getCurrentBrowseName()] = quickEntryText;
            }
        };

        function addEntry()
        {
            const quickEntryText = quickEntries[skyward.browse.getCurrentBrowseName()];

            if (quickEntryText)
            {
                const entry = skyward.controls.getValue(quickEntryText.find(".codeEELDescription"));

                if (entry.length != 0)
                {
                    const typeCode = quickEntryText.data().quickEntryTextTypeCode;
                    const modalLayer = skyward.modalLayer.getLayerFromElement(this);

                    $.ajax(
                        {
                            url: `${skyward.global.virtualDir}SkySys/QuickEntryText/AddEntry`,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                entry: entry,
                                typeCode: typeCode
                            },
                            success: function (data)
                            {
                                if (data.success)
                                {
                                    skyward.controls.setValue(quickEntryText, data.id);
                                }
                            },
                            complete: function ()
                            {
                                skyward.window.closePopup(modalLayer);
                            }
                        });
                }
                else
                {
                    const input = quickEntryText.find(".codeEELDescription");
                    if (input.get(0))
                    {
                        const attr = quickEntryText.data("placeholder-warning-on-add-empty");
                        if (attr && attr.length != 0)
                        {
                            input.attr("placeholder", attr);
                            input.off("CodeEelClosed", clearPlaceHolderText);
                            $(input).on("CodeEelClosed", clearPlaceHolderText);
                        }
                    }
                }
            }
        }

        function addFromWorkflow()
        {
            const addButton = $(this);

            if (addButton.hasClass('ui-disabled'))
            {
                return;
            }

            skyward.window.checkLoadContent(
                'popup',
                'Workflow',
                'WorkflowInstance',
                'Create/SkySys/QuickEntryText/Add',
                null,
                {
                    "Workflow.UserIDOwner": addButton.data("useridOwner"),
                    "Workflow.TypeCode": $("#quickEntryTextTypeCode").val()
                }
            );
        }

        function clearPlaceHolderText(event)
        {
            event.target.placeholder = "";
        }

        const events =
        {
            init: skyward.quickEntryText.registerQuickEntryText,
            addEntry,
            addFromWorkflow
        };
        skyward.events.registerEvents("quickEntryText", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
